"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsPageHighchartsOptionsProvider = void 0;
const React = __importStar(require("react"));
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const EventHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventHighchartsOptionsProvider");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const EventsPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageModelProvider");
const lodash_1 = __importDefault(require("lodash"));
const CompositeChartJSONModel_1 = require("src/hello_assets/src/components/model/compositeChart/CompositeChartJSONModel");
const EventsPageHighchartsOptionsProvider = (props) => {
    const pageModelContext = (0, EventsPageModelProvider_1.useEventsPageModelContext)();
    const pageDataContext = (0, EventsPageDataProvider_1.useEventsPageDataContext)();
    const urlJSONModel = pageDataContext.stateFns.getURLJSONModel();
    const stateError = { isError: pageDataContext.state.isError, error: pageDataContext.state.error };
    const asPercents = urlJSONModel.getChartSettingsJSONModel().isAsPercents();
    const aggregation = urlJSONModel.getCompositeChartAggregationJSONModel().getAggregation();
    const formModelSerialized = pageModelContext.pageModelStateFns.getFormJSONModel().serialize();
    const urlModelSerialized = urlJSONModel.serialize();
    const highchartsChartStatus = calculateHighchartsChartStatus(formModelSerialized, urlModelSerialized);
    return React.createElement(React.Fragment, null,
        React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: stateError, data: pageDataContext.state.data, parameters: {
                asPercents: asPercents,
                aggregation: aggregation
            }, highchartsOptionsProviderFn: EventHighchartsOptionsProvider_1.EventHighchartsOptionsProvider.getEvents, chartStatus: highchartsChartStatus }, props.children));
};
exports.EventsPageHighchartsOptionsProvider = EventsPageHighchartsOptionsProvider;
const calculateHighchartsChartStatus = (formModel, urlModel) => {
    formModel = CompositeChartJSONModel_1.CompositeChartJSONModel.makeModelStateClean(formModel);
    urlModel = CompositeChartJSONModel_1.CompositeChartJSONModel.makeModelStateClean(urlModel);
    const formModelEmpty = CompositeChartJSONModel_1.CompositeChartJSONModel.isModelEmpty(formModel);
    const urlModelEmpty = CompositeChartJSONModel_1.CompositeChartJSONModel.isModelEmpty(urlModel);
    if (urlModelEmpty) {
        // if (formModelEmpty) {
        return { status: "notLoaded" };
        // } else {
        //     return {status: "parametersChanged"}
        // }
    }
    else {
        const formModelEqualsToURLModel = lodash_1.default.isEqual(formModel, urlModel);
        if (formModelEqualsToURLModel) {
            return { status: "loaded" };
        }
        if (formModelEmpty) {
            return { status: "parametersChangedButEmpty" };
        }
        else {
            return { status: "parametersChanged" };
        }
    }
};
